import { useMemo } from 'react';

import {
  buildKaleidoscopeSpec,
  describeFacetPath,
  describeWedgePath,
} from '../utils/userIdVisualSeed';

type UserKaleidoscopeAvatarProps = {
  userId: string;
  size?: number;
  className?: string;
  title?: string;
};

function hashClipKey(userId: string): string {
  let hash = 0;
  for (let index = 0; index < userId.length; index += 1) {
    hash = (hash * 31 + userId.charCodeAt(index)) >>> 0;
  }
  return hash.toString(16);
}

export function UserKaleidoscopeAvatar({
  userId,
  size = 52,
  className = '',
  title = '用户头像',
}: UserKaleidoscopeAvatarProps) {
  const spec = useMemo(() => buildKaleidoscopeSpec(userId), [userId]);
  const clipId = useMemo(() => `kaleidoscope-clip-${hashClipKey(userId)}`, [userId]);

  return (
    <div
      title={title}
      aria-hidden
      className={`shrink-0 overflow-hidden rounded-full border border-border bg-surface ${className}`}
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={title}>
        <defs>
          <clipPath id={clipId}>
            <circle cx={size / 2} cy={size / 2} r={size / 2} />
          </clipPath>
        </defs>
        <g clipPath={`url(#${clipId})`}>
          {spec.segments.map((segment, index) => (
            <path
              key={`segment-${index}`}
              d={describeWedgePath(size, segment.startAngle, segment.endAngle)}
              fill={segment.fill}
            />
          ))}
          {spec.facets.map((facet, index) => (
            <path
              key={`facet-${index}`}
              d={describeFacetPath(size, facet)}
              fill={facet.fill}
              opacity={0.9}
            />
          ))}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={size / 2 - 0.5}
            fill="none"
            stroke={spec.ringStroke}
            strokeWidth={Math.max(1, size * 0.035)}
            opacity={0.72}
          />
        </g>
      </svg>
    </div>
  );
}
